import type { ColumnDef } from '@tanstack/react-table';
import { CheckboxControl } from './CheckboxControl';

export function createSelectionColumn<TData>(): ColumnDef<TData, unknown> {
  return {
    id: 'select',
    size: 40,
    minSize: 40,
    maxSize: 40,
    enableResizing: false,
    header: ({ table }) => {
      const checked = table.getIsAllPageRowsSelected();
      const indeterminate = table.getIsSomePageRowsSelected() && !checked;
      return (
        <CheckboxControl
          aria-label="Selecionar todos os itens desta página"
          checked={indeterminate ? 'indeterminate' : checked}
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(value === true)}
        />
      );
    },
    cell: ({ row }) => (
      <CheckboxControl
        aria-label="Selecionar item"
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(value === true)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
    enableSorting: false,
  };
}
